import LargePopup from 'components/popup/large-popup';
import React from 'react';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { SuccessButton, SuccessButtonWhiteBg } from 'components/button';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';

const FatcaOuterCont = styled.div<CommonStyledComponentProps>`
    padding: 10px;
    border-radius: 5px !important;
    .overlay{
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        z-index:100;
        display:none;
        background-color: rgba(250,250,250,0.9);
    }
    `;

const FatcaTitle = styled.p`
    margin: 8px 0 0;
    font-size: 20px;
    font-weight: 600;
    color: ${COLOR.BLACK};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    line-height: 1.19;
    margin-bottom: 8px;
    padding-bottom: 20px;
    border-bottom: solid 1px #dfeef5;
`;
const SuccessBtn = styled(SuccessButton) <CommonStyledComponentProps>`
    width: 150px;
    font-size: 14px; 
`;
const SuccessBtnWhite = styled(SuccessButtonWhiteBg) <CommonStyledComponentProps>`
    width: 150px;
    font-size: 14px; 
    border: 1px solid ${COLOR.GREEN};
    &:hover,
    &:focus,
    &:active {
        background-color: transparent;
        border-color: ${COLOR.GREEN};
        color: ${COLOR.GREEN};
    }
`;
interface FatcaModalProps {
    handleFatcaDetails: any;
    fatcaError?: boolean;
}
const FatcaDetails: React.FC<FatcaModalProps> = (props: FatcaModalProps) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return <LargePopup closable={false}>
        <FatcaOuterCont isMobile={ isMobile }>
            <section>
                { props.fatcaError ? <div className={ isMobile ? "mint-box mt15 mb16 p16" : "" } style={ isMobile ? { padding: "16px" } : { padding: "10px" } }>
                    <FatcaTitle>FATCA Compliant</FatcaTitle>
                    <p style={ {
                        fontSize: "14px",
                        color: "#757575",
                        lineHeight: "1.54"
                    } }>
                        Please confirm if you are FATCA complaint by accepting the terms. If you are not compliant then we will call you to assist with transaction.
                    </p>
                    <div className="lightboxCloseBtn" style={ isMobile ? { top: "30px" } : { top: "32px" } } onClick={ () => props.handleFatcaDetails(false,false) }></div>
                    <div style={ { display: "flex", alignItems: "center",justifyContent: "center",marginTop: "10px" } }>
                        <SuccessBtnWhite isMobile={ isMobile } onClick={()=> props.handleFatcaDetails(false,false)}>
                            Not Compliant
                        </SuccessBtnWhite>&nbsp;
                        <SuccessBtn isMobile={ isMobile } onClick={()=> props.handleFatcaDetails(false,true)}>
                            I am Compliant
                    </SuccessBtn></div>
                </div>
                    :
                    <div className={ isMobile ? "mint-box mt15 mb16 p16" : "" } style={ isMobile ? { padding: "16px" } : { padding: "10px" } }>
                        <FatcaTitle>T&C</FatcaTitle>
                        <div className="lightboxCloseBtn" style={ isMobile ? { top: "30px" } : { top: "32px" } } onClick={ () => props.handleFatcaDetails(false) }></div>
                        <p style={ {
                            fontSize: "14px",
                            color: "#757575",
                            lineHeight: "1.54"
                        } }>I am an Indian national and a tax resident of India. I declare that I am not politically exposed, neither a relative of politically exposed person. I hereby declare that the information provided is true and correct to the best of my knowledge. In the event of any change in the information provided, I will notify Turtlemint Mutual Funds Distributors Private Limited.</p>
                    </div> }
            </section>
        </FatcaOuterCont>
    </LargePopup >
}

export default FatcaDetails;